'use client';

import { createContext } from 'react';
import type { Key } from '@react-types/shared';

export type CommandMenuSubmenuTriggerMode = 'hover' | 'click';

export type CommandMenuSubmenuContextValue = {
    getSubmenuTriggerMode: (key: Key | undefined) => CommandMenuSubmenuTriggerMode | undefined;
    registerSubmenuTriggerMode: (key: Key, mode: CommandMenuSubmenuTriggerMode) => () => void;
};

export const CommandMenuSubmenuContext = createContext<CommandMenuSubmenuContextValue>({
    getSubmenuTriggerMode: () => undefined,
    registerSubmenuTriggerMode: () => () => undefined,
});
